import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer, inject } from "mobx-react";
import CategoryFilterBlock from "./CategoryFilterBlock";
import ProductFilterBlock from "./ProductFilterBlock";

import { Utils } from "arv-reactcomponents";

@inject("HeaderStore")
@observer
class ProductFilters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFixed: false,
      isScrollBottom: false,
    };
  }

  componentDidMount() {
    if (this.props.isFixable) {
      this.onScrollFix();
    }
  }

  onScrollFix() {
    let prevScroll = Utils.windowScroll().top;
    Utils.onElementScroll(window, ({ scrollTop }) => {
      if (
        document.body.scrollHeight - scrollTop - window.innerHeight - 585 <
        0
      ) {
        this.setState({
          isFixed: false,
          isScrollBottom: true,
        });
      } else if (this.props.HeaderStore.isFixed) {
        this.setState(
          {
            isFixed: true,
            isScrollBottom: false,
          },
          () => {
            this.filterSectionRef.scrollTop += scrollTop - prevScroll;
            prevScroll = scrollTop;
          },
        );
      } else {
        this.setState({
          isFixed: false,
          isScrollBottom: false,
        });
      }
    });
  }

  get isFixableClassName() {
    return (this.props.isFixable && "is-fixable") || "";
  }

  get isFixedClassName() {
    return (this.state.isFixed && "is-fixed") || "";
  }

  get isScrollBottomClassName() {
    return (this.state.isScrollBottom && "is-bottom") || "";
  }

  render() {
    const { filters } = this.props;
    const isDesktop = windowWidth => (windowWidth || window.innerWidth) > 768;
    if (!filters) return null;
    return (
      <section
        className={`
          nw-productfilters
          ${this.isFixableClassName}
          ${this.isFixedClassName}
          ${this.isScrollBottomClassName}
        `}
      >
        <div
          className="nwc-custom-scrollbar nw-productfilters-filtersscrollable"
          ref={context => {
            this.filterSectionRef = context;
          }}
        >
          <div className="nw-productfilters-filterscontainer">
            <CategoryFilterBlock.component
              device-info={isDesktop}
              categoryfilters={filters.articleType}
              newArrivalsfilters={filters.newArrivals}
              onSalefilters={filters.onSale}
            />
            <ProductFilterBlock.component
              device-info={isDesktop}
              filterBy={filters.filterBy}
            />
          </div>
        </div>
      </section>
    );
  }
}

ProductFilters.wrappedComponent.defaultProps = {
  isFixable: false,
  filters: null,
};

ProductFilters.wrappedComponent.propTypes = {
  isFixable: PropTypes.bool,
  HeaderStore: PropTypes.shape({
    isFixed: PropTypes.bool.isRequired,
  }).isRequired,
  filters: PropTypes.shape({}),
};

export { default as CategoryFilterBlock } from "./CategoryFilterBlock";
export { default as FilterList } from "./FilterList";
export * as ProductFilterBlock from "./ProductFilterBlock";
export * as StickyFilterBlock from "./StickyFilterBlock";
export { default as PriceFilter } from "./PriceFilter";
export { default as FilterActionsWrapper } from "./FilterActionsWrapper";

const getFinalComponent = component =>
  inject("HeaderStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: ProductFilters.wrappedComponent,
  component: ProductFilters,
};

export default ProjectComponent;
